<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>

<main class="tw-pt-16 lg:tw-py-12 lg:tw-px-[24px] main-bg">
    <div class="container">
        <h2
            class="!tw-text-[30px] md:!tw-text-[40px] !tw-mb-[20px] md:!tw-mb-[50px] !tw-text-center md:!tw-text-left !tw-font-semibold"
        >
            {{ "INSURANCE_PAGE.TITLE" | translate }}
        </h2>
    </div>
    <section
        class="container md:tw-mx-auto tw-mb-[50px] tw-w-[95%] md:tw-w-full tw-flex tw-flex-col-reverse lg:tw-flex-row tw-gap-[50px] tw-bg-[#FFD000] tw-rounded-3xl tw-p-[35px]"
    >
        <div class="tw-flex tw-flex-col tw-justify-between">
            <img
                src="/assets/images/insurance/liberty.png"
                alt="Liberty Insurance"
                class="lg:tw-w-[150px] xl:tw-w-[200px] tw-h-auto tw-hidden lg:tw-block"
            />

            <h2
                class="lg:!tw-ml-[48px] xl:!tw-ml-[66px] !tw-mt-0 md:!tw-my-[25px] lg:!tw-text-[18px] xl:!tw-text-[30px] !tw-font-bold lg:tw-text-left tw-text-center"
            >
                {{
                    selectedLanguage == "en"
                        ? content.banner.title
                        : content.banner.titleBm
                }}
            </h2>
            <p
                [innerHTML]="
                    selectedLanguage == 'en'
                        ? content.banner.desc
                        : content.banner.descBm
                "
                class="lg:!tw-ml-[48px] xl:!tw-ml-[66px] !tw-mb-[50px] lg:tw-text-left tw-text-center"
            ></p>
        </div>
        <div class="tw-relative">
            <img
                src="/assets/images/insurance/liberty.png"
                alt="Liberty Insurance"
                class="tw-w-[150px] tw-mb-[20px] tw-h-auto tw-mx-auto lg:tw-hidden"
            />
            <div
                class="hero-img tw-relative lg:tw-top-[-50px] tw-mx-auto lg:tw-mx-0"
            ></div>
        </div>
    </section>

    <section
        class="container tw-mb-[50px] tw-items-center tw-justify-between tw-flex tw-flex-col lg:tw-flex-row tw-gap-[10px]"
    >
        <div
            class="md:tw-ml-[30px] tw-max-w-[600px] lg:tw-text-left tw-text-center"
        >
            <h2>
                {{
                    selectedLanguage == "en"
                        ? content.who.title
                        : content.who.titleBm
                }}
            </h2>
            <p
                class="who-description"
                [innerHTML]="
                    selectedLanguage == 'en'
                        ? content.who.desc
                        : content.who.descBm
                "
            ></p>
        </div>
        <div class="tw-relative">
            <img
                src="/assets/images/insurance/about.png"
                class="lg:tw-max-w-[370px] xl:tw-max-w-[520px] tw-mx-auto"
                alt="about"
            />
        </div>
    </section>
    <section class="container tw-mb-[50px]">
        <h2 class="text-center !tw-mb-[20px] !tw-font-semibold">
            {{
                selectedLanguage == "en"
                    ? content.benefits.title
                    : content.benefits.titleBm
            }}
        </h2>
        <div
            class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 xl:tw-grid-cols-4 tw-justify-center tw-gap-[20px]"
        >
            <div
                class="tw-p-[30px] tw-rounded-3xl tw-border-[2px] tw-border-gray-300 tw-text-center tw-flex tw-flex-col tw-items-center tw-gap-[20px]"
                *ngFor="let item of content.benefits.options"
            >
                <img [src]="item.img" class="tw-h-[116px]" [alt]="item.title" />
                <h3
                    class="!tw-font-semibold !tw-m-0 !tw-h-[56px]"
                    [innerHTML]="
                        selectedLanguage == 'en' ? item.title : item.titleBm
                    "
                ></h3>
                <p
                    class="!tw-m-0"
                    *ngIf="item.desc || item.descBm"
                    [innerHTML]="
                        selectedLanguage == 'en' ? item.desc : item.descBm
                    "
                ></p>
                <p
                    class="!tw-m-0"
                    *ngIf="item.addFeat || item.addFeatBm"
                    [innerHTML]="
                        selectedLanguage == 'en' ? item.addFeat : item.addFeatBm
                    "
                ></p>
            </div>
        </div>
    </section>
    <section class="container tw-px-0 md:tw-px-3">
        <div class="tw-grid tw-gap-[30px] tw-grid-cols-3">
            <div
                class="tw-bg-[#FFFAE5] tw-hidden lg:tw-block tw-p-[30px] tw-pt-[72px] tw-rounded-l-3xl tw-h-full tw-relative tw-min-h-[500px]"
            >
                <img
                    class="tw-absolute lg:tw-h-[106px] xl:tw-h-[132px] tw-right-[20px] lg:tw-top-[-33px] xl:tw-top-[-10px]"
                    src="/assets/images/insurance/blue_ball.png"
                    alt="blue ball"
                />
                <h2
                    [innerHTML]="
                        selectedLanguage == 'en'
                            ? content.form.title
                            : content.form.titleBm
                    "
                ></h2>

                <p class="tw-max-w-[300px]">
                    {{
                        selectedLanguage == "en"
                            ? content.form.desc
                            : content.form.descBm
                    }}
                </p>

                <img
                    class="tw-absolute tw-left-[20px] tw-bottom-[10px] tw-h-[170px]"
                    src="/assets/images/insurance/orange_ball.png"
                    alt="orange ball"
                />
            </div>
            <div
                class="tw-bg-[#FFFAE5] tw-px-[15px] tw-py-[50px] tw-relative lg:tw-p-0 lg:tw-bg-transparent tw-col-span-3 lg:tw-col-span-2"
            >
                <img
                    class="tw-absolute tw-block lg:tw-hidden tw-h-[106px] tw-right-[20px] tw-top-[-45px]"
                    src="/assets/images/insurance/blue_ball.png"
                    alt="blue ball"
                />
                <div class="tw-block lg:tw-hidden tw-mb-[30px]">
                    <h2
                        [innerHTML]="
                            selectedLanguage == 'en'
                                ? content.form.title
                                : content.form.titleBm
                        "
                    ></h2>
                    <p class="tw-max-w-[300px]">
                        {{
                            selectedLanguage == "en"
                                ? content.form.desc
                                : content.form.descBm
                        }}
                    </p>
                </div>
                <app-project-insurance-form
                    (onSubmit)="sendProjectInsuranceLead($event)"
                    [selectedLanguage]="selectedLanguage"
                />
            </div>
        </div>
    </section>
</main>

<app-footer [selectedLanguage]="selectedLanguage" />
